import React from 'react';
import {Navigate} from 'react-router-dom';
import {route} from '../constants/routes';
import {WithChildren} from '../types/helpers';
import {LOGIN_EXTERNAL_LINK} from '../constants/env';
import {useViewer} from '../hooks/auth';

export const PrivateRoute: React.FC<WithChildren> = ({children}) => {
  const isAuth = useViewer();

  if (!isAuth && LOGIN_EXTERNAL_LINK) return <Navigate to={route.redirectToLogin.path} replace />;

  return <>{children}</>;
};
